export const TRANSLATIONS_NAMESPACE = 'form-viewer';

//# sourceMappingURL=translations.js.map